import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { departmentActions } from '../../_actions';
import Progress from '../Common/Progress';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '90%',
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    formControl: {
        width: '25vh'
    },
});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class DepartmentFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 'ADD',
            modalTitle: 'Add Department',
            openProgress: false,
            DepartmentId: '',
            DepartmentName: '',
            DepartmentLocate: '',
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open) {
            if (nextProps.departmentData && nextProps.departmentData !== undefined && nextProps.departmentData !== this.props.departmentData) {
                this.setState({
                    DepartmentId: nextProps.departmentData.DepartmentId,
                    DepartmentName: nextProps.departmentData.DepartmentName,
                    DepartmentLocate: nextProps.departmentData.DepartmentLocate,
                    mode: 'EDIT',
                    modalTitle: 'Edit Department'
                });
            }
            else {
                this.setState({
                    mode: 'ADD',
                    modalTitle: 'Add Department',
                })
            }
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleClose = () => {
        this.cleanData();
        this.props.close();
    }

    cleanData() {
        this.setState({
            mode: 'ADD',
            modalTitle: 'Add Department',
            openProgress: false,
            DepartmentId: '',
            DepartmentName: '',
            DepartmentLocate: '',
        })
    }

    handleSave = () => {
        const DataProcessing = async () => {
            try {
                this.setState({
                    openProgress: true,
                })

                const inputData = {
                    DepartmentId: this.state.DepartmentId,
                    DepartmentName: this.state.DepartmentName,
                    DepartmentLocate: this.state.DepartmentLocate,
                    CreatedUserId: this.props.user.id,
                    UpdatedUserId: this.props.user.id
                }

                if (this.state.mode === 'ADD') {
                    await this.props.dispatch(departmentActions.insert(inputData));
                }
                else if (this.state.mode === 'EDIT') {
                    await this.props.dispatch(departmentActions.update(inputData));
                }

                await this.props.dispatch(departmentActions.getAll());

                await this.handleClose();
            } catch (e) {
                console.error("Problem", e)
            }
        }

        DataProcessing();
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            {this.state.modalTitle}
                        </Typography>

                        <Grid container>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    disabled={this.state.mode === 'ADD' ? false : true}
                                    label="DepartmentId"
                                    id="DepartmentId"
                                    fullWidth
                                    className={classes.textField}
                                    onChange={this.handleChange('DepartmentId')}
                                    value={this.state.DepartmentId}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    label="DepartmentName"
                                    id="DepartmentName"
                                    fullWidth
                                    className={classes.textField}
                                    onChange={this.handleChange('DepartmentName')}
                                    value={this.state.DepartmentName}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="DepartmentLocate">Department Locate</InputLabel>
                                    <Select
                                        value={this.state.DepartmentLocate}
                                        onChange={this.handleChange('DepartmentLocate')}
                                        inputProps={{
                                            name: 'DepartmentLocate',
                                            id: 'DepartmentLocate',
                                        }}
                                    >
                                        <MenuItem value='TW'>TW</MenuItem>
                                        <MenuItem value='HK'>HK</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div style={{ marginTop: '40px' }} />
                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, departments } = state;

    return {
        user,
        users,
        departments,
    };
}

DepartmentFormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(DepartmentFormComponent);


// WEBPACK FOOTER //
// ./src/components/Admin/DepartmentFormComponent.js